















import { Vue, Component, Emit, Prop, Watch, Ref } from 'vue-property-decorator'

@Component
export default class QuantityComboBox extends Vue {
  @Prop({ type: String, default: 'Quantity' })
  public label!: string

  @Prop({ type: Array, default: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] })
  public items!: number[]

  @Prop({ type: Number, default: 1 })
  public quantity!: number

  @Prop({ type: Boolean, default: true })
  public required!: boolean

  @Prop({ type: Array, default: null})
  public rules!: any[]

  public defaultRules = [
    (v: number) => v > 0 || 'Quantity must be greater than zero'
  ]

  @Ref() readonly inputField!: HTMLInputElement

  @Watch('quantity')
  public quantityWatch() {
    if (!this.quantity) {
      return
    }
      this.input()
  }

  @Emit()
  public input() {
    return this.quantity
  }

  @Emit('updateQuantity')
  public updateQuantity(quantity: number | string) {
    if (typeof quantity === 'string') {
      return parseInt(quantity)
    }

    return quantity
  }

  // Input element method pass through
  public focus() {
    this.inputField.focus()
  }
  public blur() {
    this.inputField.blur()
  }
}
